export default "__VITE_ASSET__FuNw6C6u__"